const payments = {
  loading: true,
  detailsLoading: true,
  buttonLoading: false,
  opened: '',
  list: {},
  details: {
    selectedCreditCard: '',
    totalDue: 0,
    totalSurcharge: 0,
    total: 0,
    selectedPaymentMethod: '',
  },
}
const PaymentsReducer = function (state = payments, action) {
  switch (action.type) {
    case 'TOGGLE_PAYMENTS_LOADING': {
      return {
        ...state,
        loading: action.value,
      }
    }
    case 'TOGGLE_PAYMENT_LOADING': {
      return {
        ...state,
        detailsLoading: action.value,
      }
    }
    case 'TOGGLE_PAYMENT_BUTTON_LOADING': {
      return {
        ...state,
        buttonLoading: action.value,
      }
    }
    case 'SELECT_PAYMENT': {
      return {
        ...state,
        opened: action.order,
      }
    }
    case 'UPDATE_PAYMENTS': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        list: {
          ...state.list,
          ...newList,
        },
      }
    }
    case 'UPDATE_PAYMENTS_DETAILS': {
      return {
        ...state,
        details: {
          ...state.details,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_PAYMENTS_DETAILS_PAYMENT': {
      return {
        ...state,
        details: {
          ...state.details,
          [action.key]: action.value,
        },
      }
    }
    default: {
      return state
    }
  }
}

export default PaymentsReducer
